












import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";

@Component({
  components: {},
})
export default class Footer extends Vue {
  ICP: string;
  data() {
    return {
      ICP: "京ICP备18062012号-1",
    };
  }
  mounted() {
    if (window.location.href.indexOf("378188718.xyz") > -1) {
      document.title = "个人接口测试";
      this.ICP = "京ICP备18062012号-2";
    } else {
      document.title = "去找屋";
      this.ICP = "京ICP备18062012号-1";
    }
  }
}
